import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useSiteContent } from "@/context/SiteContentContext";

// Homepage "HOMERANGE GOODS" editorial section (Reference Image 1).
// Cream background, centered eyebrow + serif headline, 4 products (image + name + arrow),
// centered outline "SHOP HOMERANGE" button. No price/badges/cart here — editorial only.
export function MerchStrip() {
  const { goods } = useSiteContent();
  const [products, setProducts] = useState(null);
  useEffect(() => { api.shopFeatured().then((d) => setProducts(d.products || [])).catch(() => setProducts([])); }, []);

  if (goods && goods.enabled === false) return null;
  if (products !== null && products.length === 0) return null;

  const items = products || Array.from({ length: 4 });

  return (
    <section className="bg-paper px-5 sm:px-10 py-20 lg:py-24" data-testid="home-goods-section">
      <div className="max-w-[1180px] mx-auto text-center">
        <p className="hr-overline text-blaze" data-testid="goods-eyebrow">{goods?.eyebrow || "HOMERANGE GOODS"}</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-[3.4rem] text-charcoal tracking-tight mt-3">{goods?.headline || "Made for wherever you call home."}</h2>
        <p className="text-charcoal/55 mt-4 max-w-md mx-auto text-sm sm:text-base">{goods?.description}</p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 mt-12">
          {items.map((p, i) => (
            p ? (
              <Link key={p.id} to={`/shop/${p.slug}`} className="group text-left" data-testid={`goods-card-${p.id}`}>
                <div className="aspect-square overflow-hidden bg-bone">
                  <img src={p.homepage_image || p.primary_image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[600ms] ease-out" />
                </div>
                <div className="flex items-center justify-between mt-3">
                  <span className="text-charcoal font-medium text-[15px] pr-2">{p.title}</span>
                  <ArrowRight size={18} className="text-blaze shrink-0 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ) : <div key={i} className="aspect-square bg-bone animate-pulse" />
          ))}
        </div>

        <div className="mt-12">
          <Link to="/shop" className="inline-flex items-center gap-3 border border-blaze/70 text-blaze uppercase tracking-[0.18em] text-xs font-semibold px-10 py-3.5 hover:bg-blaze hover:text-white transition-colors" data-testid="shop-homerange-btn">
            {goods?.button_text || "SHOP HOMERANGE"} <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
